import axios from "axios";
import React, { useEffect, useState } from "react";
// react plugin used to create charts
import { Line, Pie } from "react-chartjs-2";
import { useHistory } from "react-router";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { URL_API } from "variable";
// core components
import {
  dashboard24HoursPerformanceChart,
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";

function Dashboard() {
  const history = useHistory();
  const [arrticleCounter, setArticleCounter] = useState();
  const [enquiriesCounter, setEnquiriesCounter] = useState();
  const [adminCounter, setAdminCounter] = useState();
  const adminName = localStorage.getItem("admin_name");

  useEffect(() => {
    const isAdmin = localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras");
    if (isAdmin == null) {
      history.push("/admin/login-page");
    } else {
    }

    getData();
  });

  const getData = () => {
    axios
      .get(URL_API + "dashboard")
      .then((response) => {
        // console.log('rasdfasdfasdasdfadsfasdfads',response?.data?.articles);
        setArticleCounter(response?.data?.articles);
        setEnquiriesCounter(response?.data?.enquiries);
        setAdminCounter(response?.data?.admins);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateArticles = () => {
    getData();
  };

  return (
    <>
      <div className="content d-flex justify-content-center align-items-center text-align-center">
        <Row>
          <Col lg="12">
            <div className="d-flex justify-content-center align-items-center">
              <h2 className="textAlignCenter">Welcome to Admin</h2>
            </div>

          </Col>
        </Row>





      </div>
    </>
  );
}

export default Dashboard;
